import MultiframePaginationBars from './Bars/Bars'
import MultiframePaginationDots from './Dots/Dots'

export { MultiframePaginationBars, MultiframePaginationDots }
